import React, { Ref, forwardRef } from 'react';
import classnames from 'classnames';
import { Button } from '../button';
import { IconCross } from '../icons';

export type ModalHeaderCloseButtonProps = React.HTMLAttributes<HTMLButtonElement>;

export const ModalHeaderCloseButton = forwardRef(
  ({ className, ...props }: ModalHeaderCloseButtonProps, ref: Ref<HTMLButtonElement>) => {
    const classNames = classnames(className, 'airtame-modal__header-close');

    return (
      <span className="airtame-modal__header-close-wrapper">
        <Button buttonType="secondary" size="small" className={classNames} ref={ref} {...props}>
          <IconCross />
        </Button>
      </span>
    );
  }
);

ModalHeaderCloseButton.displayName = 'ModalHeaderCloseButton';
